import React from "react";
import { Link } from "react-router-dom";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { queryParams } from "../../helpers/formatting";

class Covid19AppointmentError extends React.Component {
    constructor(props) {
        super(props);
        this.locUrl = '/findcare/vaccine';
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Covid19AppointmentError.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {   

        const { providerSearchModel, xid } = this.props;

        let findcareSearchParms = "?" + queryParams({
            location: providerSearchModel && providerSearchModel.Location ? providerSearchModel.Location : null,
            visitTypeId: providerSearchModel && providerSearchModel.visitTypeId ? providerSearchModel.visitTypeId : null,
            xid: xid ? xid : null
        });

        this.locUrl = this.locUrl + findcareSearchParms;

        return (
            <div className="row covid19-appt-error-container">
                <div className="col-12 text-center">
                    <h1 className="step-heading step-heading-md no-prog-bar">There are no appointments available at this location.</h1>
                    <p>
                        <Link to={this.locUrl}>See other locations for appointment times.</Link>
                    </p>
                </div>
            </div>
        );
    }
}

export default Covid19AppointmentError;